import { render, staticRenderFns } from "./partnerAccount.vue?vue&type=template&id=47ab1128"
import script from "./partnerAccount.vue?vue&type=script&lang=js"
export * from "./partnerAccount.vue?vue&type=script&lang=js"
import style0 from "./partnerAccount.vue?vue&type=style&index=0&id=47ab1128&prod&itemscope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports